import React, { useState, useRef } from 'react';

import { uuid } from 'uuidv4';
import QRCode from 'qrcode.react';
import { FaBarcode, FaList, FaQrcode } from 'react-icons/fa';
import { AxiosInstance } from 'axios';
import { useModal } from '../../../../../../hooks/Modal';

import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';

import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import Button from '../../Forms/Button';

import { usePrinter } from '../../../../../../hooks/PrinterHook';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import api from '../../../../../../services/api';
import { decodeCracha } from '../Cracha';
import { string } from 'yup';
import { useLoading } from 'src/hooks/LoadingHook';
import { convertToXLSX } from 'src/utils/download';


interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef?: AxiosInstance;
}

export default function CrachaLote({ idKey = '' }): JSX.Element {
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();
  const { addPrint, printIt } = usePrinter();
  const { configuration } = useConfiguration();
  const { addLoading, removeLoading } = useLoading();
  const key = uuid();



  const print = () => {
    printIt();
  };

  const getLastName = (last_name) => {

    if (!last_name) {
      return last_name || '';
    }

    if (configuration?.theme_data?.cracha_split_last_name === "yes") {

      const index = last_name.indexOf(' ');

      if (index >= 0) {
        const splits = last_name.split(" ");
        const length = splits.length - 1;
        return splits?.[length] || '';
      }
      else {
        return last_name;
      }

    }
    else {

      return last_name;
    }


  }

  const downloadData = (list) => {
    convertToXLSX(list)
  }


  const handleQR = async (): Promise<void> => {


    addLoading({ title: 'Carregando', key: 'loading' })


    let list: Array<Array<String>> = [
      ['NOME']

    ];

    const data = await api.get(`/v3/search-credenciados/evento`, { params: { limitItems: 10000, where: { project_id: configuration?.url }, order: { orderBy: 'name', direction: 'asc' } } });

    const dataRows = data?.data?.rows || [];

    dataRows?.sort((a, b) => {

      const nameA = a?.name?.toLowerCase?.() || '';
      const nameB = b?.name?.toLowerCase?.() || '';
      return nameA.localeCompare(nameB);

    })

    if (dataRows) {
      dataRows?.map((line, index) => {

        if (line?.client_id && line?.checkin === 'Sim' && line?.ticket !== 'Patrocinadores' && (line?.comprador?.toLowerCase()?.indexOf('palestrante') < 0 && line?.comprador?.toLowerCase()?.indexOf('patrocinador') < 0)) {

          list.push([line?.name])
        }
      });

    }
    removeLoading('loading')


    const content = <div style={{ width: '100%' }}><h2 style={{ color: '#fff' }}>Gerar Lista</h2>
      <Button onClick={() => downloadData(list)}>Download</Button>

      <div style={{ background: '#fff', width: '100%', textAlign: 'center' }}>

        <table className='tableRef'>
          <tbody>

            {list?.map(item => {

              return <tr>
                <td>{item?.[0]}</td>

              </tr>

            })}

          </tbody>
        </table>

      </div>

    </div>;

    if (content) {
      const keyModal = addModal({ title: 'Gerar lista de sorteio', content, key });
    }



  };

  const moduleQRCode = (): JSX.Element => (


    <button className="searchButton" title="Lista para sorteio" type="button" onClick={handleQR}>
      <FaList />
    </button>
  );

  return moduleQRCode();
}
